import React, { Fragment, useRef, useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

import Card from "../../../component/card/Card";
import Starter from "../../../component/Starter";
import TopInput from "./TopInput";
import {
  attendanceActions,
  locationActions
} from "../../../redux/actions";
import { helperFunction } from "../../../constant/helper";
import { types } from "../../../redux/type";
import isEmpty from "../../../validation/isEmpty";
import LocationList from "./LocationList";
import { listOfDepartment } from "./attendanceStaticData";

const initialState = {
  date: "",
  Filter: "",
  locationId: "1",
  dataType: ""
};

const DepartmentAttendance = () => {
  const componentRef = useRef();

  const loginType = localStorage.loginType;
  const dispatch = useDispatch();
  const [dailyArray, setDailyArray] = useState([]);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);

  const { locationError, locations } = useSelector(
    (state) => state.location
  );
  const { currentUser } = useSelector((state) => state.auth);

  const {
    date,
    locationId,
    attendanceError,
    dailyDepartmentAttendance,
    attendanceLoading
  } = useSelector((state) => state.attendance);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (!isEmpty(dailyDepartmentAttendance)) {
      setDailyArray(
        dailyDepartmentAttendance.map((location) => {
          const dailyDepartment = [];
          const obj = _.mapKeys(
            location.department,
            "workerDepartment"
          );
          listOfDepartment.forEach((departmentValue) => {
            const workerDepartment = isEmpty(obj[departmentValue])
              ? "-"
              : obj[departmentValue].workerDepartment;
            const total = isEmpty(obj[departmentValue])
              ? 0
              : obj[departmentValue].total;
            dailyDepartment.push({
              workerDepartment,
              total
            });
          });

          return {
            dailyDepartment,
            locationName: location.locationName,
            totalPresent: location.totalSum
          };
        })
      );
    }
  }, [dailyDepartmentAttendance]);

  useEffect(() => {
    setValues({
      ...values,
      date,
      locationId
    });
  }, [date, locationId]);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
    if (attendanceError) {
      helperFunction.toastHelper("error", attendanceError);
    }
  }, [locationError, attendanceError]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    dispatch(attendanceActions.clearAttendanceErrors());
    dispatch(attendanceActions.clearAttendanceResult());
    return () => {
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
      dispatch(attendanceActions.clearAttendanceErrors());
      dispatch(attendanceActions.clearAttendanceResult());
    };
  }, []);

  const fetchDailyAttendance = (e) => {
    e.preventDefault();
    dispatch(attendanceActions.setAttendanceLoading(true));
    dispatch(attendanceActions.clearAttendanceErrors());
    dispatch(attendanceActions.clearAttendanceResult());
    const empty = isEmpty(loginType);

    if (empty) {
      const errorData = {
        data: { message: "PLEASE LOGOUT AND LOGIN AGAIN" },
        status: 401
      };
      dispatch({
        type: types.AttendanceTypes.ATTENDANCE_GET_ERRORS,
        payload: errorData
      });
    } else {
      dispatch(
        attendanceActions.getDailyDepartmentAttendance(
          values,
          loginType
        )
      );
    }
  };

  const onHeaderChange = () => {
    return listOfDepartment.map((department, departmentIndex) => (
      <th
        key={departmentIndex}
        className="text-center"
        style={{ fontSize: 12 }}
      >
        {department}
      </th>
    ));
  };

  const showUserList = (departmentAttendanceList) => {
    // console.log(departmentAttendanceList);
    if (!isEmpty(departmentAttendanceList)) {
      return departmentAttendanceList.map((mapData, parentIndex) => {
        return (
          <LocationList
            mapData={mapData}
            parentIndex={parentIndex}
            key={parentIndex}
          />
        );
      });
    }
  };

  return (
    <Starter
      topBarTitle="Department Attendance"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Attendance Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Attendance</a>
          </li>
          <li className="breadcrumb-item active">
            Department Attendance
          </li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          currentUser={currentUser}
          loading={attendanceLoading}
          onChange={handleInputChange}
          onSubmit={fetchDailyAttendance}
          allLocations={!isEmpty(allLocations) ? allLocations : []}
        />
      </Card>
      <Card>
        <div
          className="table-responsive"
          ref={componentRef}
          style={{ height: "700px", overflow: "auto" }}
        >
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>

                <th className="text-center">Location Name</th>
                {onHeaderChange()}
                <th className="text-center">Total</th>
              </tr>
            </thead>
            <tbody>{showUserList(dailyArray)}</tbody>
          </table>
        </div>
        <div className="row mt-3">
          <div className="col-sm-1"></div>
          <div className="col-sm-4"></div>
          <div className="col-2">
            <ReactHTMLTableToExcel
              className="btn btn-dark btn-block text-white"
              table="products-datatable"
              filename={`${values.date}`}
              sheet="Sheet"
              buttonText="Export"
            />
          </div>
          <div className="col-sm-1"></div>
          <div className="col-sm-4"></div>
        </div>
      </Card>
    </Starter>
  );
};

export default DepartmentAttendance;
